import { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useNavigate, NavLink, useParams, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf'; 
import { jsPDF as JsPDF } from 'jspdf';
import { toWords } from 'number-to-words';

// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';

import * as userActions from "../../actions/userActions";
import AccessDenied from '../common/AccessDenied';

import * as leadActions from "../../actions/leadActions";
import DisbursementMemoPage from './DisbursementMemoPage';
// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------


const WelcomeLetterPage = (props) => {
    const { leadId, id } = useParams();
    const location = useLocation();
    const { actions, usersData, fetchLeadIdDocument, allLeadDocumentByLeadData, userRoleType, isActive, leadInfo, backToLeadHandler, enableCamDetailsHandler, camDetails,lmsConfigurationDetails } = props;
    const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
    const navigate = useNavigate();

    const [allUsers, setAllUsers] = useState([]);
    const [selectedDocumentFiles, setSelectedDocumentFiles] = useState([]);
    const [getLeadId, setLeadId] = useState('');
    const [allUploadLeadDocument, setAllUploadLeadDocument] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const formRef = useRef(null);
    const [propLeadId, setPropLeadId] = useState('');
    const [allDocumentTypeData, setAllDocumentTypeData] = useState([]);
    const [open, setOpen] = useState(false);
    const [viewModalInfo, setViewModalInfo] = useState([]);
    const [isVerifyDocChecked, setIsVerifyDocChecked] = useState(false);

    const [activeAllSancationDocs, setActiveAllSancationDocs] = useState([]);
    const [allLeadCheckLists, setAllLeadCheckLists] = useState([]);
    const [activeAccordionSections, setActiveAccordionSections] = useState([]);

    const [anchorCategories, setAnchorCategories] = useState([]);
    const [speciallyAbledArr, setSpeciallyAbledArr] = useState([]);
    const [residenceTypesArr, setResidenceTypesArr] = useState([]);
    const [bankingUpiArr, setBankingUpiArr] = useState([]);
    const [constitutionArr, setConstitutionArr] = useState([]);
    const [customerTypeArr, setCustomerTypeArr] = useState([]);
    const [vehicleMakerArr, setVehicleMakerArr] = useState([]);
    const [vehicleUseArr, setVehicleUseArr] = useState([]);
    const [insuranceArr, setInsuranceArr] = useState([]);
    const [vehicleModelsArr, setVehicleModelsArr] = useState([]);
    const [businessValidationProofArr, setBusinessValidationProofArr] = useState([]);
    const [turnoverIncomeArr, setTurnoverIncomeArr] = useState([]);
    const [workingCapitalCycleArr, setWorkingCapitalCycleArr] = useState([]);
    const [addedLeadCoapplicantGuarantorRows, setAddedLeadCoapplicantGuarantorRows] = useState([]);
    const [coapplicantGuarantorRows, setCoapplicantGuarantorRows] = useState([]);
    const [religionsRows, setReligionsRows] = useState([]);
    const [categoryRows, setCategoryRows] = useState([]);
    const [motherNameRows, setMotherNameRows] = useState([]);
    const [alternateMobileRows, setAlternateMobileRows] = useState([]);
    const [educationDetailsRows, setEducationDetailsRows] = useState([]);
    const [educationalBackgroundRows, setEducationalBackgroundRows] = useState([]);
    const [parmanentAddressRows, setParmanentAddressRows] = useState([]);
    const [noOfDependentsRows, setNoOfDependentsRows] = useState([]);
    const [preferredLanguageRows, setPreferredLanguageRows] = useState([]);
    const [accountTypeArr, setAccountTypeArr] = useState([]);
    const [crifDetails, setCrifDetails] = useState([]);
    const [bankDetails, setBankDetails] = useState([]);
    const [camApprovalHistory, setCamApprovalHistory] = useState([]);

    const [cAMMarginMoney, setCAMMarginMoney] = useState(0);
    const [annualIrr, setAnnualIrr] = useState(null);
    const [error, setError] = useState(null);
    const [showSanctionNote, setShowSanctionNote] = useState('');
    const [sanctionApproveLatestStatus, setSanctionApproveLatestStatus] = useState(0);
    const [sanctionApproveAndSendMailLatestStatus, setSanctionApproveAndSendMailLatestStatus] = useState(0);
    const [approveBtnAction, setApproveBtnAction] = useState(0);
    const [sendEmailBtnAction, setSendEmailBtnAction] = useState(0);
    const [openRejectAmt, setOpenRejectAmt] = useState(false);
    const [proposedRejectAmt, setproposedRejectAmt] = useState('');
    const [noOfAssetsToBeFinancedAfter, setNoOfAssetsToBeFinancedAfter] = useState('');
    const [multiofTotalAssetsNoofAssets, SetMultiofTotalAssetsNoofAssets] = useState('');

    const [isFIOpen, setIsFIOpen] = useState(false);
    const [isMiscOpen, setIsMiscOpen] = useState(false);
    const [isApplicantOpen, setIsApplicantOpen] = useState(false);
    const [isCoApplicantOpen, setIsCoApplicantOpen] = useState(false);
    const [isGuarantorOpen, setIsGuarantorOpen] = useState(false);
    const [applicationDetailsFormStatus, setApplicationDetailsFormStatus] = useState(true);
    const [applicationDetailsFormActiveTab, setApplicationDetailsFormActiveTab] = useState('english_copy');
    const [enableUpdatePdfDetails, setEnableUpdatePdfDetails] = useState(false);
    const [refNo, setRefNo] = useState('');
    const [insuranceFor, setInsuranceFor] = useState('For insurance by ckers');
    const [dealerSubvention, setDealerSubvention] = useState('Dealer Subvention');

    const [insuranceForValue, setInsuranceForValue] = useState('');
    const [dealerSubventionValue, setDealerSubventionValue] = useState('');

    const [loanAmountValue, setLoanAmountValue] = useState('');
    const [processingFeeOnFinanceAmountPlusGSTValue, setProcessingFeeOnFinanceAmountPlusGSTValue] = useState('');
    const [lessProcessingFeeIncludingGSTValue, setLessProcessingFeeIncludingGSTValue] = useState('');
    const [lessInsuranceByKotakMahindraValue, setLessInsuranceByKotakMahindraValue] = useState('');

    const [lessPreEmiTill5THJanValue, setLessPreEmiTill5THJanValue] = useState('');
    const [fileChargeValue, setFileChargeValue] = useState('');

    const [netDisbursementValue, setNetDisbursementValue] = useState('');
    const [nameOfSupplierDealerValue, setNameOfSupplierDealerValue] = useState('');

    const [exShowroomPriceValue, setExShowroomPriceValue] = useState('');
    const [insuranceAmounByDealerValue, setInsuranceAmounByDealerValue] = useState('');
    const [totalOnRoadPriceValue, setTotalOnRoadPriceValue] = useState('');
    const [assetValueVehicleVehiclesValue, setAssetValueVehicleVehiclesValue] = useState('');
    const [noOfAssetValue, setNoOfAssetValue] = useState('');
    const [totalDownPaymentByCustomerValue, setTotalDownPaymentByCustomerValue] = useState('');
    const [isReadyToModify, setIsReadyToModify] = useState(true);
    const [leadDetails, setLeadDetails] = useState([]);
    const [allLeadDocumentsArr, setAllLeadDocumentsArr] = useState([]);
    const [addedAllCoApplicants, setAddedAllCoApplicants] = useState([]);
    const [addedAllGuarantors, setAddedAllGuarantors] = useState([]);

    const [verticalTotalColspan, setVerticalTotalColspan] = useState(2);
    const [leadMoreDocuments, setLeadMoreDocuments] = useState([]);


    const [sourceDealerDetails, setSourceDealerDetails] = useState(``);
    const [currentDate, setCurrentDate] = useState(new Date());
    const [leadCity, setLeadCity] = useState('');
    const [leadName, setLeadName] = useState('');
    const [leadAddress, setLeadAddress] = useState('');
    // const [camDetails, setCamDetails] = useState([]);
    const [savedApplicationDetailsInfo, setSavedApplicationDetailsInfo] = useState([]);
    const [savedSanctionDetailsInfo, setSavedSanctionDetailsInfo] = useState([]);

    const [lessPreEmiTill5thLabel, setLessPreEmiTill5thLabel] = useState('Less: Pre-EMI Till 5TH');
    const [amountOfProcessingFee, setAmountOfProcessingFee] = useState(0);
    const [lessProcessingFeeExcludingGST, setLessProcessingFeeExcludingGST] = useState(0);

    const [feeChargesPayable, setFeeChargesPayable] = useState(0);

    const [dearlerSubventionDedcuteAmount, setDearlerSubventionDedcuteAmount] = useState('');
    const [aprValue, setAprValue] = useState(0);

    const [totalMarginMoneyReceiptAmt, setTotalMarginMoneyReceiptAmt] = useState(0);
    const [netDisbursementAmt, setNetDisbursementAmt] = useState(0);
    const [emiAllVehicle, setEmiAllVehicle] = useState(0);
    const [sLTenure, setSLTenure] = useState(0);

    const [viewDetailsOpen, setViewDetailsOpen] = useState(false);
    const [viewDetailsModalInfo, setViewDetailsModalInfo] = useState([]);

    const [loanAmountSchedule, setLoanAmountSchedule] = useState(0);
    const [interestRateSchedule, setInterestRateSchedule] = useState(0);
    const [loanDurationSchedule, setLoanDurationSchedule] = useState(0);
    const [paymentsPerYearSchedule, setPaymentsPerYearSchedule] = useState(0);
    const [allReligions, setAllReligions] = useState([]);
    const [allSocialCategory, setAllSocialCategory] = useState([]);
    const [allPreferredLanguage, setAllPreferredLanguage] = useState([]);
    const [preloaderStatus, setPreloaderStatus] = useState(false);
    const [preloaderSaveStatus, setPreloaderSaveStatus] = useState(false);
    const [allDealers, setAllDealers] = useState([]);
    const [dealerAddress, setDealerAddress] = useState('');
    const [dealerName, setDealerName] = useState('');
    const [dealerBenificaryName, setDealerBenificaryName] = useState('');
    const [dealerBankName, setDealerBankName] = useState('');
    const [dealerAccountNo, setDealerAccountNo] = useState('');
    const [dealerIfsc, setDealerIfsc] = useState('');



    function numberToIndianWords(num) {
        const a = [
            '', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine',
            'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen',
            'seventeen', 'eighteen', 'nineteen'
        ];
        const b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

        const inWords = (n) => {
            if (n < 20) return a[n];
            if (n < 100) return `${b[Math.floor(n / 10)]}${n % 10 ? ` ${a[n % 10]}` : ''}`;
            if (n < 1000) return `${a[Math.floor(n / 100)]} hundred${n % 100 ? ` and ${inWords(n % 100)}` : ''}`;
            return '';
        };

        const units = [
            { value: 10000000, label: 'crore' },
            { value: 100000, label: 'lakh' },
            { value: 1000, label: 'thousand' },
            { value: 100, label: 'hundred' }
        ];

        if (num === 0) return 'zero';

        let result = '';
        units.forEach(({ value, label }) => {
            if (num >= value) {
                const count = Math.floor(num / value);
                result += `${inWords(count)} ${label} `;
                num %= value;
            }
        });

        if (num > 0) result += inWords(num);

        return result.trim();
    }

    useEffect(() => {
        // check user is logged-in or not
        const authToken = localStorage.getItem('authToken');
        if (authToken === null) {
            navigate('/login');
        }

        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        actions.usersData(requestData);
        if (usersData.success) {
            setAllUsers(usersData.data);
        }
    }, []);

    const formattedDate = currentDate.toLocaleDateString('en-IN', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    });



    function calculateAPR(tenureMonths, emi, netDisbursement) {
        const maxIterations = 100;
        const precision = 1e-6;

        // Validate inputs
        if (
            tenureMonths <= 0 ||
            emi <= 0 ||
            netDisbursement <= 0 ||
            Number.isNaN(tenureMonths) ||
            Number.isNaN(emi) ||
            Number.isNaN(netDisbursement)
        ) {
            return 0; // or return 'Invalid input' if you prefer
        }

        let rate = 0.1 / 12; // initial guess (10% annually)
        let iteration = 0;

        while (iteration < maxIterations) {
            let npv = 0;
            let derivative = 0;

            for (let i = 1; i <= tenureMonths; i += 1) {
                npv += emi / ((1 + rate) ** i);
                derivative += -i * emi / ((1 + rate) ** (i + 1));
            }

            npv -= netDisbursement;

            const newRate = rate - npv / derivative;

            if (Math.abs(newRate - rate) < precision) {
                rate = newRate;
                break;
            }

            rate = newRate;
            iteration += 1;
        }

        return (rate * 12 * 100).toFixed(2); // Return APR as percentage
    }



    const roundNumber = (num) => {
        if (!num && num !== 0) return 0;
        return Math.round(num);
    };

    const generateSchedule = () => {
        const principal = parseFloat(loanAmountSchedule);
        const annualRate = parseFloat(interestRateSchedule) / 100;
        const totalPayments = loanDurationSchedule;
        const ratePerPeriod = annualRate / 12;

        /* const principal = parseFloat(430000);
         const annualRate = parseFloat(20.82) / 100;
         const totalPayments = 42;
         const ratePerPeriod = annualRate / 12; */

        const schedule = [];
        const payment = principal * ratePerPeriod / (1 - (1 + ratePerPeriod) ** -totalPayments);


        let remainingBalance = principal;

        for (let i = 1; i <= totalPayments; i += 1) {
            const interest = remainingBalance * ratePerPeriod;
            const principalPayment = payment - interest;
            remainingBalance -= principalPayment;

            schedule.push({
                paymentNumber: i,
                payment: roundNumber(payment).toFixed(2),
                interest: roundNumber(interest).toFixed(2),
                principal: roundNumber(principalPayment).toFixed(2),
                balance: remainingBalance > 0 ? roundNumber(remainingBalance).toFixed(2) : '0.00'
            });
        }

        return schedule;
    };


    const schedule = generateSchedule();



    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };


    const handleInputChange = (id, type, value) => {
        setReligionsRows((prev) => {
            const existingIndex = prev.findIndex((entry) => entry.id === id && entry.type === type);

            if (existingIndex !== -1) {
                // Update if already exists
                const updated = [...prev];
                updated[existingIndex].value = value;
                return updated;
            }
            // Push new entry
            return [...prev, { id, type, value }];
        });
    };

    const handleInputsetCategoryChange = (id, type, value) => {
        setCategoryRows((prev) => {
            const existingIndex = prev.findIndex((entry) => entry.id === id && entry.type === type);

            if (existingIndex !== -1) {
                // Update if already exists
                const updated = [...prev];
                updated[existingIndex].value = value;
                return updated;
            }
            // Push new entry
            return [...prev, { id, type, value }];
        });
    };

    const handleInputsetMotherNameChange = (id, type, value, field) => {
        setMotherNameRows((prev) => {
            const existingIndex = prev.findIndex((entry) => entry.id === id && entry.type === type && entry.field === field);

            if (existingIndex !== -1) {
                // Update if already exists
                const updated = [...prev];
                updated[existingIndex].value = value;
                updated[existingIndex].field = field;
                return updated;
            }
            // Push new entry
            return [...prev, { id, type, value, field }];
        });
    };

    const handleInputsetAlternateMobileChange = (id, type, value, field) => {
        setAlternateMobileRows((prev) => {
            const existingIndex = prev.findIndex((entry) => entry.id === id && entry.type === type && entry.field === field);

            if (existingIndex !== -1) {
                // Update if already exists
                const updated = [...prev];
                updated[existingIndex].value = value;
                updated[existingIndex].field = field;
                return updated;
            }
            // Push new entry
            return [...prev, { id, type, value, field }];
        });
    };

    const handleInputsetEducationDetailsChange = (id, type, value, field) => {
        setEducationDetailsRows((prev) => {
            const existingIndex = prev.findIndex((entry) => entry.id === id && entry.type === type && entry.field === field);

            if (existingIndex !== -1) {
                // Update if already exists
                const updated = [...prev];
                updated[existingIndex].value = value;
                updated[existingIndex].field = field;
                return updated;
            }
            // Push new entry
            return [...prev, { id, type, value, field }];
        });
    };

    const handleInputsetEducationalBackgroundChange = (id, type, value, field) => {
        setEducationalBackgroundRows((prev) => {
            const existingIndex = prev.findIndex((entry) => entry.id === id && entry.type === type && entry.field === field);

            if (existingIndex !== -1) {
                // Update if already exists
                const updated = [...prev];
                updated[existingIndex].value = value;
                updated[existingIndex].field = field;
                return updated;
            }
            // Push new entry
            return [...prev, { id, type, value, field }];
        });
    };

    const handleInputsetParmanentAddressChange = (id, type, value, field) => {
        setParmanentAddressRows((prev) => {
            const existingIndex = prev.findIndex((entry) => entry.id === id && entry.type === type && entry.field === field);

            if (existingIndex !== -1) {
                // Update if already exists
                const updated = [...prev];
                updated[existingIndex].value = value;
                updated[existingIndex].field = field;
                return updated;
            }
            // Push new entry
            return [...prev, { id, type, value, field }];
        });
    };

    const handleInputsetNoOfDependentsChange = (id, type, value, field) => {
        setNoOfDependentsRows((prev) => {
            const existingIndex = prev.findIndex((entry) => entry.id === id && entry.type === type && entry.field === field);

            if (existingIndex !== -1) {
                // Update if already exists
                const updated = [...prev];
                updated[existingIndex].value = value;
                updated[existingIndex].field = field;
                return updated;
            }
            // Push new entry
            return [...prev, { id, type, value, field }];
        });
    };

    const handleInputsetPreferredLanguageChange = (id, type, value) => {
        setPreferredLanguageRows((prev) => {
            const existingIndex = prev.findIndex((entry) => entry.id === id && entry.type === type);

            if (existingIndex !== -1) {
                // Update if already exists
                const updated = [...prev];
                updated[existingIndex].value = value;
                return updated;
            }
            // Push new entry
            return [...prev, { id, type, value }];
        });
    };

    useEffect(() => {
        console.log("religionsRows updated:", religionsRows);

         console.log("lmsConfigurationDetails:", lmsConfigurationDetails);

    }, [religionsRows, categoryRows, preferredLanguageRows, motherNameRows,lmsConfigurationDetails]);

    const formatDateForValue = (date) => {
        if (!date || Number.isNaN(new Date(date).getTime())) {
            return '';  // Return an empty string for invalid or empty dates
        }

        const newDate = new Date(date);
        const year = newDate.getFullYear();
        const month = String(newDate.getMonth() + 1).padStart(2, '0');
        const day = String(newDate.getDate()).padStart(2, '0');

        return `${day}/${month}/${year}`;
    };

    const formatOnlyMonthYearValue = (date) => {
        if (!date || Number.isNaN(new Date(date).getTime())) {
            return '';  // Return an empty string for invalid or empty dates
        }

        const newDate = new Date(date);
        const year = newDate.getFullYear();
        const monthName = newDate.toLocaleString('en-US', { month: 'long' }); // Get full month name

        return `${monthName} ${year}`;
    };


    const clickCcmTab = () => {
        backToLeadHandler('cam');
        enableCamDetailsHandler(true);
        const timer = setTimeout(() => {
            const divElement = document.getElementById("pills-disbursement_memo-tab");
            if (divElement) {
                divElement.click();
            }
        }, 2000);
        return () => clearTimeout(timer);
    };

    useEffect(() => {
        if (leadInfo?.data?.length > 0) {

            const leadDetailsVal = leadInfo.data[0];
            setLeadDetails(leadDetailsVal);

            const name = leadInfo.data[0]?.name;
            setLeadName(name);

            const city = leadInfo.data[0]?.city;
            setLeadCity(city);

            const fullAddress = leadInfo.data[0]?.full_address;
            setLeadAddress(fullAddress);

            // console.log("lead info - ", leadInfo?.data);
        }

    }, [leadInfo]);


    const saveLeadPDDData = async (action = '', notes = '') => {

        let actionStatus = '0';
        let submitStatus = true;

        if (action === 'approve') {
            actionStatus = '1';
            if (notes === '') {
                toast.error("Notes is required.", {
                    position: "top-right",
                });
                submitStatus = false;
            }
        } else if (action === 'reject') {
            actionStatus = '2';

            if (notes === '') {
                toast.error("Notes is required.", {
                    position: "top-right",
                });
                submitStatus = false;
            }
        } else if (action === 'reversal') {
            actionStatus = '3';

            if (notes === '') {
                toast.error("Notes is required.", {
                    position: "top-right",
                });
                submitStatus = false;
            }

        }
        setPreloaderSaveStatus(true);
        if (submitStatus) {
            if (id !== undefined) {
                setPropLeadId(atob(id));
                setLeadId(propLeadId);
                
                const obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": atob(id),'api_calling_module' :'welcome_letter', 'action' : applicationDetailsFormActiveTab };
                
                    // console.log("obj lead id- ", obj);
                    const requestData = encryptData(obj);
                    const response = actions.saveLeadPDDData(requestData);

                    response.then((result) => {
                        setPreloaderSaveStatus(false);
                        if (result.data.success === 1) {                            
                            const resultArr = result.data.data;
                            const detailsInfo = resultArr?.latestEntryRow; 

                            
                                    toast.success("Welcome letter details saved successfully.", {
                                        position: "top-right",
                                    });
                                
                        }
                    }).catch((error) => {
                        setPreloaderSaveStatus(false);
                        //  console.error("Promise rejected -  source data :", error); 
                    });
                
            }
        }

    };

    function calculateIRR(cashFlows, guess = 0.1) {
        const maxIteration = 1000;
        const precision = 1e-7;
        let rate = guess;

        for (let iter = 0; iter < maxIteration; iter += 1) {
            let npv = 0;
            let derivative = 0;

            for (let t = 0; t < cashFlows.length; t += 1) {
                npv += cashFlows[t] / (1 + rate) ** t;
                derivative -= t * cashFlows[t] / (1 + rate) ** (t + 1);
            }

            const newRate = rate - npv / derivative;

            if (Math.abs(newRate - rate) < precision) {
                return newRate;
            }

            rate = newRate;
        }

        throw new Error("IRR calculation did not converge");
    }

 

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.masterDocumentTypeData(requestData, false);
        response.then((result) => {
            // console.log("Promise resolved -  source data:", result); 
            if (result.data.success === 1) {
                const results = result.data.data.data
                const filteredResultArr = results.filter((item) => item.status === "1");
                const sortedResultArr = filteredResultArr.sort((a, b) =>
                    a.document_type.localeCompare(b.document_type)
                );
                setAllDocumentTypeData(sortedResultArr);
            }
        }).catch((error) => {
            //  console.error("Promise rejected -  source data :", error); 
        });

    }, [setAllDocumentTypeData]);

    const handleDocumentFileChange = (e) => {
        const files = Array.from(e.target.files);
        const base64Files = [];

        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                const base64Data = event.target.result;
                const fileName = file.name;
                base64Files.push({ file: base64Data, name: fileName });
                if (base64Files.length === files.length) {
                    setSelectedDocumentFiles(base64Files);
                }
            };
            reader.readAsDataURL(file);
        });
    };

    const onSubmit = (data) => {

        setPropLeadId(atob(id));
        setLeadId(propLeadId);

        if (data.document_type.trim() === "") {
            toast.error("No document type has been selected.", {
                position: "top-right",
            });
        } else if (!selectedDocumentFiles || selectedDocumentFiles.length === 0) {
            toast.error("No file has been selected.", {
                position: "top-right",
            });
        } else if (data.document_note.trim() === "") {
            toast.error("Note is blank.", {
                position: "top-right",
            });
        } else {

            const params = { "lead_id": propLeadId, "document_type": data.document_type, "document_note": data.document_note, "document_file": selectedDocumentFiles };

            const requestData = encryptData(params);
            const response = actions.addEditLeadDocument(requestData, navigate);

            response.then((result) => {
                // console.log("Promise resolved - addEditLeadDocument form:", result); 
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });

                    const obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": propLeadId };
                    // console.log("obj lead id- ", obj);
                    const requestData = encryptData(obj);
                    const response = actions.getUploadLeadDocument(requestData);

                    response.then((result) => {
                        // console.log("Promise resolved -  source data:", result); 
                        if (result.data.success === 1) {
                            const results = result.data.data.data;
                            const resultArr = Object.keys(results).map((key) => results[key]);
                            setAllUploadLeadDocument(resultArr);
                        }
                    }).catch((error) => {
                        //  console.error("Promise rejected -  source data :", error); 
                    });

                    reset();
                    setSelectedDocumentFiles("");

                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                }
            }).catch((error) => {
                toast.error(error, {
                    position: "top-right",
                });
            });
        }
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const filteredItems = (allUploadLeadDocument ?? []).filter(item =>
        item.formatetdID.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.assignedUser.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.statusName.toLowerCase().includes(searchQuery.toLowerCase())
    );


    const startIndex = (currentPage - 1) * config.ITEMS_PER_PAGE;
    const endIndex = startIndex + config.ITEMS_PER_PAGE;
    const paginatedItems = filteredItems.slice(startIndex, endIndex);
    const totalPages = Math.ceil(filteredItems.length / config.ITEMS_PER_PAGE);

    const onRowClickAction = (itemObj, btnAction) => {
        setViewModalInfo(itemObj);
        setOpen(true);
    }

    const veridateDoc = (data, actionStatus) => {

        const verifyDocStatus = (actionStatus) ? 1 : 0;
        const params = { "id": data.id, "status": verifyDocStatus };

        const requestData = encryptData(params);
        const response = actions.verifyDocuments(requestData);
        response.then((result) => {
            if (result.data.success === 1) {
                toast.success(result.data.message, {
                    position: "top-right",
                });
             //   getUploadLeadDocumentData();
            } else {
                toast.error(result.data.message, {
                    position: "top-right",
                });
            }
        }).catch((error) => {
            toast.error(error, {
                position: "top-right",
            });
        });
    };

    const handleNoBank = (event, item) => {
        setIsVerifyDocChecked(event.target.checked)
        veridateDoc(item, event.target.checked);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleToggle = (action) => {

        if (action !== '') {
            setApplicationDetailsFormActiveTab(action);
            setApplicationDetailsFormStatus(true);
        } else {
            setApplicationDetailsFormStatus(prevState => !prevState);
        }
       // saveLeadPDDData();
    }

    const handleToggleUpdateDetails = () => {
        setEnableUpdatePdfDetails(prevState => !prevState);
    }

    const handleToggleSaveDetails = () => {
        saveLeadPDDData();
    }

    const handleSourceDealerChange = (event) => {
        setSourceDealerDetails(event.target.value);
    }

    const handleFormChange = (event) => {
        if (event.target.name === 'refNo') {
            setRefNo(event.target.value);
        }
        if (event.target.name === 'insuranceFor') {
            setInsuranceFor(event.target.value);
            if (event.target.value === '') {
                setInsuranceFor('For insurance by ckers');
            }
        }
        if (event.target.name === 'dealerSubvention') {
            setDealerSubvention(event.target.value);
            if (event.target.value === '') {
                setDealerSubvention('Dealer Subvention');
            }
        }

        if (event.target.name === 'loanAmountValue') {
            setLoanAmountValue(event.target.value);
        }

        if (event.target.name === 'processingFeeOnFinanceAmountPlusGSTValue') {
            setProcessingFeeOnFinanceAmountPlusGSTValue(event.target.value);
        }

        if (event.target.name === 'lessProcessingFeeIncludingGSTValue') {
            setLessProcessingFeeIncludingGSTValue(event.target.value);
        }

        if (event.target.name === 'lessInsuranceByKotakMahindraValue') {
            setLessInsuranceByKotakMahindraValue(event.target.value);
        }

        if (event.target.name === 'lessPreEmiTill5THJanValue') {
            setLessPreEmiTill5THJanValue(event.target.value);
        }

        if (event.target.name === 'fileChargeValue') {
            setFileChargeValue(event.target.value);
        }

        if (event.target.name === 'netDisbursementValue') {
            setNetDisbursementValue(event.target.value);
        }

        if (event.target.name === 'nameOfSupplierDealerValue') {
            setNameOfSupplierDealerValue(event.target.value);
        }

        if (event.target.name === 'exShowroomPriceValue') {
            setExShowroomPriceValue(event.target.value);
        }

        if (event.target.name === 'assetValueVehicleVehiclesValue') {
            setAssetValueVehicleVehiclesValue(event.target.value);
        }

        if (event.target.name === 'noOfAssetValue') {
            setNoOfAssetValue(event.target.value);
        }

        if (event.target.name === 'insuranceAmounByDealerValue') {
            setInsuranceAmounByDealerValue(event.target.value);
        }

        if (event.target.name === 'totalOnRoadPriceValue') {
            setTotalOnRoadPriceValue(event.target.value);
        }


        if (event.target.name === 'insuranceForValue') {
            setInsuranceForValue(event.target.value);
        }

        if (event.target.name === 'dealerSubventionValue') {
            setDealerSubventionValue(event.target.value);
        }


    }

    const [htmlContent, setHtmlContent] = useState('');
    const editorRef = useRef(null);


    const handleInput = () => {
        setHtmlContent(editorRef.current.innerHTML);
    };

    const [formRejectitem, setFormRejectitem] = useState({
        notes: '',
    });

    const btnOpenRejectData = (approveBtnAction, sendEmail = '0') => {    // buttonFun 
        setApproveBtnAction(approveBtnAction);
        setOpenRejectAmt(true);
        setSendEmailBtnAction(sendEmail);
    };

    const handleCloseRejectAmt = () => {     // Modal onclick closedFun
        setApproveBtnAction(0);
        setOpenRejectAmt(false);
        setSendEmailBtnAction(0);
    };

    const handleRejectFormSubmit = (data) => {
        if (data.notes === '') {
            toast.error("Notes is required.", {
                position: "top-right",
            });
        } else {

            if (approveBtnAction === '1') {
                // saveLeadPDDData('approve',data.notes);
            }

            if (approveBtnAction === '2') {
                // saveLeadPDDData('reject',data.notes);
            }

            if (approveBtnAction === '3') {
                // saveLeadPDDData('reversal',data.notes);
            }
        }
    }

    const handleAmtRejectChange = (e) => {
        const totalAmt = e.target.value;
        setFormRejectitem((prevState) => ({
            ...prevState,
            totalAmt,
        }));
    }

    const printRef = useRef();
    const handleDownloadPdf = async () => {
        const element = printRef.current;
        if (!element) {
            console.error('Printable element not found');
            return;
        }

        setPreloaderStatus(true);

        /* ---------- 1. Render the DOM node to a single canvas ---------- */
        const canvas = await html2canvas(element, {
            scale: 2,          // lower scale → smaller PDF, still readable on A4
            useCORS: true,       // remote images must have Access‑Control‑Allow‑Origin
            allowTaint: false,
            scrollY: -window.scrollY
        });

        /* ---------- 2. Prepare jsPDF ---------- */
        const pdf = new JsPDF({ orientation: 'p', unit: 'mm', format: 'a4' });
        const pdfW = pdf.internal.pageSize.getWidth();
        const pdfH = pdf.internal.pageSize.getHeight();
        const imgW = pdfW;
        const imgH = (canvas.height * pdfW) / canvas.width;      // keep aspect ratio
        const pagePxH = Math.floor((canvas.width * pdfH) / pdfW);   // canvas pixels per PDF page
        const pages = Math.ceil(canvas.height / pagePxH);

        /* ---------- 3. Re‑use ONE off‑screen canvas for all page slices ---------- */
        const pageCanvas = document.createElement('canvas');
        pageCanvas.width = canvas.width;
        const pageCtx = pageCanvas.getContext('2d');

        /* ---------- 4. Loop over pages ---------- */
        for (let page = 0; page < pages; page += 1) {
            const startY = page * pagePxH;
            const sliceH = Math.min(pagePxH, canvas.height - startY);

            // resize helper canvas only when height changes (last page)
            if (pageCanvas.height !== sliceH) { pageCanvas.height = sliceH; }

            pageCtx.clearRect(0, 0, canvas.width, sliceH);
            pageCtx.drawImage(canvas, 0, startY, canvas.width, sliceH, 0, 0, canvas.width, sliceH);
            const imgData = pageCanvas.toDataURL('image/jpeg', 0.7);

            // add to PDF
            if (page > 0) pdf.addPage();
            pdf.addImage(imgData, 'JPEG', 0, 0, imgW, (sliceH * pdfW) / canvas.width);
        }

        /* ---------- 5. Build filename & save ---------- */
        const ts = new Date().toISOString().replace(/[:.]/g, '-');
        const prefix =
            applicationDetailsFormActiveTab === 'english_copy'
                ? 'Welcome_letter_english'
                : applicationDetailsFormActiveTab === 'hindi_copy'
                    ? 'Welcome_letter_hindi'
                    : 'Welcome_letter_english';

        pdf.save(`${prefix}_${ts}.pdf`);
        setPreloaderStatus(false);
        saveLeadPDDData();
    };


    const getLastDueDate = (startDate, tenureMonths) => {
        if (!startDate || !tenureMonths) return '';
        const date = new Date(startDate);
        date.setMonth(date.getMonth() + tenureMonths - 1);

        // Format as YYYY-MM-DD
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');

        return `${yyyy}-${mm}-${dd}`;
    };

    return (
        <>
            <div id="main-wrap" className='mt-4'>
                <div className='row justify-content-between'>
                    <div className="col-md-12 mb-3">
                        <button type="button" className={
                            applicationDetailsFormActiveTab === "english_copy"
                                ? "btn btn-success text-white btn-auto"
                                : "btn btn-default text-white btn-auto"
                        } onClick={() => handleToggle('english_copy')}
                            title="Visible To : Credit , Manager , Credit Head and Superadmin Users"  >
                            English
                        </button>
                        &nbsp; <button type="button" className={
                            applicationDetailsFormActiveTab === "hindi_copy"
                                ? "btn btn-success text-white btn-auto"
                                : "btn btn-default text-white btn-auto"
                        } onClick={() => handleToggle('hindi_copy')}
                            title="Visible To : Credit , Manager , Credit Head and Superadmin Users" >
                            Hindi
                        </button>&nbsp;&nbsp;
                    </div>


                    <div className="">
                        <div>
                            <div className="applicationDetailsClass" style={
                                isReadyToModify
                                    ? { padding: "20px" }
                                    : { padding: "20px" }
                            }>
                                <div ref={printRef}>

                                    <div style={
                                        isReadyToModify
                                            ? { border: "2px solid grey", padding: "5px",fontSize: "18px" }
                                            : { border: "2px solid grey", padding: "5px" ,fontSize: "18px"}
                                    }>

                                        <div style={
                                            isReadyToModify
                                                ? { border: "1px solid grey", padding: "20px" }
                                                : { border: "1px solid grey", padding: "20px" }
                                        }>

                                            <div >
                                                {(camDetails?.cam_lender === 'Vivriti') ? (
                                                    <>
                                                        <div>
                                                            <img src="/assets/vivriti-logo.png" className="login-logo-" alt="Vivriti Logo" style={{ display: "inline" }} />

                                                            <img src="/assets/ckern-logo.png" className="login-logo-" alt="CKers Logo" style={{ display: "inline", float: "right" }} />
                                                        </div>

                                                    </>
                                                ) : (
                                                    <>
                                                        <div style={{ textAlign: 'center' }}>
                                                            <img src="/assets/ckern-logo.png" className="login-logo-" alt="CKers Logo" style={{ display: "inline" }} />
                                                        </div>

                                                    </>
                                                )}
                                            </div>

                                            { /* english_copy section  :  START HERE */}
                                            <div className={applicationDetailsFormActiveTab === "english_copy" ? " row  col-md-12 mt-4" : "d-none row  col-md-12 mt-4"}>


                                                <div className="col-md-6"><b>To,</b></div>
                                                <div className="col-md-6" style={{ textAlign: "right" }}><b>Date: {formattedDate}</b></div>
                                                <div className="col-md-12 mt-2">
                                                    <b>{camDetails?.cam_customer_name}</b>
                                                    <div className="mt-2"> {camDetails?.cam_address}
                                                    {(camDetails?.cam_permanent_landmark !== '' || camDetails?.cam_permanent_city !== '' || camDetails?.cam_permanent_district !== '' || camDetails?.cam_permanent_state !== '' || camDetails?.cam_permanent_pin !== '') && (<>
                                                       <br/>{camDetails?.cam_permanent_landmark} {camDetails?.cam_permanent_city} {camDetails?.cam_permanent_district} {camDetails?.cam_permanent_state} {camDetails?.cam_permanent_pin}
                                                    </>)}</div>
                                                    {camDetails?.cam_mobile_no !=='' && (
                                                       <div>
                                                        Contact No: {camDetails?.cam_mobile_no}</div>
                                                    )}
                                                   

                                                    <div className="mt-4">
                                                        Dear Customer,
                                                        <div className="mt-2">
                                                            We welcome you to {(camDetails?.cam_lender === 'Vivriti') ? (<>Vivriti Capital Limited</>) : (<>cKers Finance Private Limited</>)} Family and thank you for choosing us as your Lending Partner in your growth.</div>
                                                        <div className="mt-1">
                                                            We are pleased to inform you that your loan has been disbursed following are the mentioned details of your Commercial Vehicle Loan:
                                                        </div>
                                                    </div>

                                                    <div style={{ clear: 'both' }}>&nbsp;</div>
                                                    <table style={{ border: '1px', width: '100%' , fontSize: '18px'}} className='pdfTable'>
                                                        <tr>
                                                            <td style={{ borderWidth: '1px' , fontSize: '18px'}}><b>Agreement No. Loan</b></td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}><b>Amount</b></td>
                                                            <td style={{ borderWidth: '1px' , fontSize: '18px'}}><b>EMI </b></td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}><b>Pre EMI Date </b></td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}><b>Pre EMI Amount </b></td>
                                                            <td style={{ borderWidth: '1px' , fontSize: '18px'}}><b>Vehicle Model </b></td>
                                                        </tr>

                                                        <tr>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}>{leadDetails?.AgreementNo}</td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}>{camDetails?.dmemo_loan_amount}</td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}>{camDetails?.dmemo_emi_per_vehicle}</td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}>{(camDetails?.dmemo_pre_emi_end_date !== '0000-00-00') ? formatDateForValue(camDetails?.dmemo_pre_emi_end_date) : ""}</td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}>{camDetails?.dmemo_pre_emi}</td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}>{camDetails?.dmemo_vehicle_models}</td>

                                                        </tr>

                                                    </table>

                                                    <div className="mt-3">
                                                        As you are aware, that your EMI due date is 5th of every month thus it has to be paid on 05th of every Month. Please ensure that your bank account has sufficient balance prior to that. This will avoid levy of additional charges for non-receipt of payment. Your repayment will start from <b>{(camDetails?.dmemo_first_emi_interest_date !== '0000-00-00') ? formatDateForValue(camDetails?.dmemo_first_emi_interest_date) : ""}.</b>
                                                    </div>

                                                    <div className="mt-3">
                                                        If you require any further details on your Electric Vehicle - Commercial Loan Account, please contact us at any of the mobile numbers given below. Our employees will be glad to assist you.
                                                    </div>

                                                    <div className="mt-3">
                                                        <b>
                                                            We are pleased to inform that you are also eligible for Top Up Loan related to Battery, Insurance or any other utility required for the vehicle financed by us subject to clean repayment record and condition of the vehicle.
                                                        </b>
                                                    </div>

                                                    <div style={{ clear: 'both' }}>&nbsp;</div>
                                                    <table style={{ border: '1px', width: '100%' , fontSize: '18px'}} className='pdfTable'>
                                                        <tr>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}><b>Services</b></td>
                                                            <td style={{ borderWidth: '1px' , fontSize: '18px'}}><b>Email Id</b></td>
                                                            <td style={{ borderWidth: '1px' , fontSize: '18px'}}><b>Mobile No. </b></td>
                                                        </tr>

                                                        <tr>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}>Loan Apply</td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}>retailoperations@ckersfinance.in</td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}>
                                                                {(camDetails?.cam_lender === 'Vivriti') ? (
                                                                    <>
                                                                        9650383700
                                                                    </>) : (<>
                                                                        9599812331 / 9599812325
                                                                    </>)
                                                                }
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}>Loan Detail or Account Statement
                                                                {(camDetails?.cam_lender === 'Vivriti') && (
                                                                    <><br />For complaints and resolutions</>
                                                                )}

                                                            </td>
                                                            <td style={{ borderWidth: '1px' , fontSize: '18px'}}>
                                                                {(camDetails?.cam_lender === 'Vivriti') ? (
                                                                    <>
                                                                        customercare@ckersfinance.in
                                                                        <br />grievanceredressal@vivriticapital.com
                                                                    </>) : (
                                                                    <>
                                                                        retailoperations@ckersfinance.in
                                                                    </>
                                                                )
                                                                }

                                                            </td>
                                                            <td style={{ borderWidth: '1px' , fontSize: '18px'}}>
                                                                {(camDetails?.cam_lender === 'Vivriti') ? (
                                                                    <>
                                                                        8882247409
                                                                        <br />044- 40074801
                                                                    </>) : (<>
                                                                        9205550310
                                                                    </>)
                                                                }

                                                            </td>
                                                        </tr>

                                                    </table>

                                                    <div className="mt-3">
                                                        We value your relationship with us and assure you of our best services always.
                                                    </div>

                                                    <div className="mt-4">
                                                        <b> Best Regards,<br />
                                                            {(camDetails?.cam_lender === 'Vivriti') ? (<>Vivriti Capital Limited</>) : (<>cKers Finance Private Limited</>)}</b>
                                                    </div>


                                                    <div style={{ textAlign: "center" }} className="mt-5">
                                                        {(camDetails?.cam_lender === 'Vivriti') ? (
                                                            <>
                                                                <h4>Vivriti Capital Limited</h4>

                                                                <div className="mt-2">
                                                                    Please quote your Electric Vechicle- Commercial Loan Account number whenever you contact us.
                                                                    <div>
                                                                        For any clarification you are requested to contct on:</div>
                                                                </div>

                                                                <div className="mt-2">
                                                                    <b>Address :</b> Prestige Zackria Metropolitan, No. 200/1-8, 2nd Floor, Block 1, Anna Salai, Chennai - 600002
                                                                </div>

                                    <br />
                                    {(() => { 
                                        const phoneConfig = lmsConfigurationDetails.find(
                                    item => item.configuration_name === "Welcome Letter Phone No"
                                    );

                                    return (
                                    <>
                                        <b>Phone No :</b> {phoneConfig?.configuration_details || "+91 8882247409"} 
                                        <br />
                                    </>
                                    );
                                    })()}
                                     
                                    {(() => { 
                                        const emailConfig = lmsConfigurationDetails.find(
                                    item => item.configuration_name === "Welcome Letter Email"
                                    );

                                    return (
                                    <>
                                        <b>Email :</b> {emailConfig?.configuration_details || "retailoperations@ckersfinance.in, cpa@ckersfinance.in"}
                                    </>
                                    );
                                    })()}
                                                            </>
                                                        ) : (
                                                            <>
                                                                <h4>cKers Finance Private Limited</h4>

                                                                <div className="mt-3">
                                                                    Please quote your Electric Vechicle- Commercial Loan Account number whenever you contact us.
                                                                    <div>
                                                                        For any clarification you are requested to contct on:</div>
                                                                </div>

                                                                <div className="mt-2">
                                                                    <b>Address :</b>Building No-24-30, First Floor, Okhla Industrial Area Phase - III, New Delhi 110020, India
                                                                </div>

                                    <br />
                                    {(() => { 
                                        const phoneConfig = lmsConfigurationDetails.find(
                                    item => item.configuration_name === "Welcome Letter Phone No"
                                    );

                                    return (
                                    <>
                                        <b>Phone No :</b> {phoneConfig?.configuration_details || "+91 8882247409"}
                                        <br />
                                    </>
                                    );
                                    })()}
                                                                
                                    {(() => { 
                                        const emailConfig = lmsConfigurationDetails.find(
                                    item => item.configuration_name === "Welcome Letter Email"
                                    );

                                    return (
                                    <>
                                        <b>Email :</b> {emailConfig?.configuration_details || "retailoperations@ckersfinance.in, cpa@ckersfinance.in"}
                                    </>
                                    );
                                    })()}
                                                            </>
                                                        )}
                                                    </div>


                                                </div>
                                                <div style={{ clear: 'both' }}>&nbsp;</div>
                                            </div>
                                            { /* english_copy section  :  END HERE */}


                                            { /* hindi_copy section  :  START HERE */}
                                            <div className={applicationDetailsFormActiveTab === "hindi_copy" ? " row  col-md-12 mt-4" : "d-none row  col-md-12 mt-4"}>

                                                <div className="col-md-6"><b>सेवा में,</b></div>
                                                <div className="col-md-6" style={{ textAlign: "right" }}><b>दिनाक: {formattedDate}</b></div>
                                                <div className="col-md-12  mt-2">
                                                    <b>{camDetails?.cam_customer_name}</b>
                                                     <div className="mt-2">
                                                    {camDetails?.cam_address}
                                                    {(camDetails?.cam_permanent_landmark !== '' || camDetails?.cam_permanent_city !== '' || camDetails?.cam_permanent_district !== '' || camDetails?.cam_permanent_state !== '' || camDetails?.cam_permanent_pin !== '') && (<>
                                                        <br /> {camDetails?.cam_permanent_landmark} {camDetails?.cam_permanent_city} {camDetails?.cam_permanent_district} {camDetails?.cam_permanent_state} {camDetails?.cam_permanent_pin}
                                                    </>)}
                                                    </div>
                                                     {camDetails?.cam_mobile_no !=='' && (
                                                       <div>
                                                        Contact No: {camDetails?.cam_mobile_no}</div>
                                                    )}

                                                    <div className="mt-4">
                                                        प्रिय ग्राहक,
                                                        <div className="mt-2">
                                                            {(camDetails?.cam_lender === 'Vivriti') ? (<>विवृति कैपिटल लिमिटेड </>) : (<>सीकेर्स फाइनेंस प्राइवेट लिमिटेड</>)} परिवार में आपका हार्दिक स्वागत है। हम आपके आभारी हैं कि आपने अपने व्यावसायिक विकास के     इस महत्वपूर्ण चरण में हमें अपने उधार भागीदार के रूप में चुना।
हमें आपको यह सूचित करते हुए अत्यंत हर्ष हो रहा है कि आपका ऋण सफलतापूर्वक वितरित कर दिया गया है।
आपके व्यावसायिक इलेक्ट्रिक वाहन ऋण के अंतर्गत, आपकी <b>ईएमआई की देय तिथि प्रत्येक माह की 05 तारीख को</b> निर्धारित की गई है।

                                                        </div>
                                                    </div>

                                                    <div style={{ clear: 'both' }}>&nbsp;</div>
                                                    <table style={{ border: '1px', width: '100%', fontSize: '18px' }} className='pdfTable'>
                                                        <tr>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}><b>अनुबंध संख्या</b></td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}><b>ऋृण राशि</b></td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}><b>ईएमआई राशि </b></td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}><b>प्री ईएमआई तिथि  </b></td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}><b>प्री ईएमआई राशि </b></td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}><b>वाहन मॉडल </b></td>
                                                        </tr>

                                                        <tr>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}>{leadDetails?.AgreementNo}</td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}>{camDetails?.dmemo_loan_amount}</td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}>{camDetails?.dmemo_emi_per_vehicle}</td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}>{(camDetails?.dmemo_pre_emi_end_date !== '0000-00-00') ? formatDateForValue(camDetails?.dmemo_pre_emi_end_date) : ""}</td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}>{camDetails?.dmemo_pre_emi}</td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}>{camDetails?.dmemo_vehicle_models}</td>

                                                        </tr>

                                                    </table>

                                                    <div className="mt-3">
                                                        आपसे विनम्र अनुरोध है कि कृपया सुनिश्चित करें कि <b>हर महीने की 5 तारीख से पहले आपके बैंक खाते में पर्याप्त शेष राशि</b> उपलब्ध हो, ताकि किसी भी प्रकार के अतिरिक्त शुल्क से बचा जा सके। आपका पुनर्भुगतान {(camDetails?.dmemo_first_emi_interest_date !== '0000-00-00') ? formatDateForValue(camDetails?.dmemo_first_emi_interest_date) : ""} से प्रारंभ होगा।

                                                         <div className="mt-3">
हम यह भी बताते हुए प्रसन्न हैं कि हमारा यह ऋण केवल वाहन की बैटरी तक सीमित वित्तपोषण विकल्प प्रदान करता है, बशर्ते कि पूरी ऋण अवधि के दौरान किसी भी महीने की ईएमआई बाउंस न हो।
यदि आपको अपने ऋण खाते, भुगतान प्रक्रिया या अन्य किसी जानकारी की आवश्यकता हो, तो कृपया नीचे दिए गए मोबाइल नंबरों पर बेझिझक हमसे संपर्क करें।
हमारे प्रतिनिधि आपकी हर संभव सहायता करने के लिए सदैव तत्पर हैं।
</div>

                                                    </div>

                                                    <div style={{ clear: 'both' }}>&nbsp;</div>
                                                    <table style={{ border: '1px', width: '100%', fontSize: '18px' }} className='pdfTable'>
                                                        <tr>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}><b>सेवाएं</b></td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}><b>ईमेल आईडी</b></td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}><b>मोबाइल नंबर </b></td>
                                                        </tr>

                                                        <tr>
                                                            <td style={{ borderWidth: '1px' , fontSize: '18px'}}>ऋण आवेदन</td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}>retailoperations@ckersfinance.in</td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}>
                                                                {(camDetails?.cam_lender === 'Vivriti') ? (
                                                                    <>
                                                                        9650383700
                                                                    </>) : (<>
                                                                        9599812331 / 9599812325
                                                                    </>)
                                                                }
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td style={{ borderWidth: '1px' , fontSize: '18px'}}>ऋण विवरण या खाता विवरण 
                                                                {(camDetails?.cam_lender === 'Vivriti') && (
                                                                    <><br />शिकायतों एवं समाधान के लिए</>
                                                                )}

                                                            </td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}>
                                                                {(camDetails?.cam_lender === 'Vivriti') ? (
                                                                    <>
                                                                        customercare@ckersfinance.in
                                                                        <br />grievanceredressal@vivriticapital.com
                                                                    </>) : (
                                                                    <>
                                                                        retailoperations@ckersfinance.in
                                                                    </>
                                                                )
                                                                }

                                                            </td>
                                                            <td style={{ borderWidth: '1px', fontSize: '18px' }}>
                                                                {(camDetails?.cam_lender === 'Vivriti') ? (
                                                                    <>
                                                                        8882247409
                                                                        <br />044- 40074801
                                                                    </>) : (<>
                                                                        9205550310
                                                                    </>)
                                                                }

                                                            </td>
                                                        </tr>

                                                    </table>

                                                    <div className="mt-3">
                                                        <b>एक बार पुनः, विवृति कैपिटल लिमिटेड परिवार की ओर से आपका स्वागत करते हैं। हम आपके उज्ज्वल और समृद्ध भविष्य की कामना करते हैं।</b>
                                                        <div className="mt-3">
                                                        हम अपने साथ आपके संबंधों को महत्व देते हैं और आपको हमेशा हमारी सर्वोत्तम सेवाओं का आश्वासन देते हैं।
                                                        </div>
                                                    </div>

                                                    <div className="mt-4">
                                                        <b>सधन्यवाद,<br />
                                                            {(camDetails?.cam_lender === 'Vivriti') ? (<>विवृति कैपिटल लिमिटेड</>) : (<>सीकेर्स फाइनेंस प्राइवेट लिमिटेड</>)}</b>
                                                    </div>


                                                    <div style={{ textAlign: "center" }} className="mt-5">
                                                        {(camDetails?.cam_lender === 'Vivriti') ? (
                                                            <>
                                                                <h4>विवृति कैपिटल लिमिटेड</h4>

                                                                 <div className="mt-2">
                                                                    जब भी आप हमसे संपर्क करें कृपया अपना इलेक्ट्रिक वाहन-वाणिज्यिक ऋण खाता नंबर उद्धृत करें।
                                                                    <div>
                                                                       किसी भी स्पष्टीकरण के लिए आपसे संपर्क करने का अनुरोध किया जाता है</div>
                                                                </div>

                                                                <div className="mt-2">
                                                                    <b>पता - </b>प्रेस्टीज जैकरिया मेट्रोपॉलिटन, नंबर 200/1-8, दूसरी मंजिल, ब्लॉक 1, अन्ना सलाई, चेन्नई 600002
                                                                </div>

                                                                <br />
                                    {(() => { 
                                        const phoneConfig = lmsConfigurationDetails.find(
                                    item => item.configuration_name === "Welcome Letter Phone No"
                                    );

                                    return (
                                    <>
                                  
                                        <b>फोन नंबर:</b> {phoneConfig?.configuration_details || "+91 8882247409"}
                                        <br />
                                    </>
                                    );
                                    })()}

                                     {(() => { 
                                        const emailConfig = lmsConfigurationDetails.find(
                                    item => item.configuration_name === "Welcome Letter Email"
                                    );

                                    return (
                                    <>
                                        <b>ईमेल आईडी:</b> {emailConfig?.configuration_details || "retailoperations@ckersfinance.in, cpa@ckersfinance.in"}
                                    </>
                                    );
                                    })()}
                                                               
                                                            </>
                                                        ) : (
                                                            <>
                                                                <h4>सीकेर्स फाइनेंस प्राइवेट लिमिटेड</h4>

                                                                <div className="mt-2">
                                                                    जब भी आप हमसे संपर्क करें कृपया अपना इलेक्ट्रिक वाहन-वाणिज्यिक ऋण खाता नंबर उद्धृत करें।
                                                                    <div>
                                                                       किसी भी स्पष्टीकरण के लिए आपसे संपर्क करने का अनुरोध किया जाता है</div>
                                                                </div>

                                                                <div className="mt-2">
                                                                    <b>पता - </b>बिल्डिंग नं-24-30, प्रथम तल, ओखला औद्योगिक क्षेत्र, फेज़ - III, नई दिल्ली - 110020
                                                                </div>

                                                                <br />
                                    {(() => { 
                                    const phoneConfig = lmsConfigurationDetails.find(
                                    item => item.configuration_name === "Welcome Letter Phone No"
                                    );

                                    return (
                                    <>
                                  
                                        <b>फोन नंबर:</b> {phoneConfig?.configuration_details || "+91 8882247409"}
                                        <br />
                                    </>
                                    );
                                    })()}
                                    
                                     {(() => { 
                                        const emailConfig = lmsConfigurationDetails.find(
                                    item => item.configuration_name === "Welcome Letter Email"
                                    );

                                    return (
                                    <>
                                        <b>ईमेल आईडी:</b> {emailConfig?.configuration_details || "retailoperations@ckersfinance.in, cpa@ckersfinance.in"}
                                    </>
                                    );
                                    })()}
                                                            </>
                                                        )}
                                                    </div>



                                                    <div style={{ clear: 'both' }}>&nbsp;</div>
                                                </div>
                                                <div style={{ clear: 'both' }}>&nbsp;</div>
                                            </div>

                                            { /* hindi_copy section  :  END HERE */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />


                            {(!enableUpdatePdfDetails) ? (
                                <>
                               {/* <button type="button" className="btn btn-primary text-white btn-auto" onClick={handleToggleUpdateDetails} >Update Details</button> */ }

                                 <button type="button" className="btn btn-primary text-white btn-auto d-none" onClick={handleToggleSaveDetails} >Save Welcome Letter {preloaderSaveStatus && (
                                        <>
                                            <div
                                                className="spinner-border small-preloader"
                                                role="status"
                                            >
                                                <span className="visually-hidden">
                                                    {" "}
                                                    Loading...
                                                </span>
                                            </div>
                                        </>
                                    )}</button> 
</>
                            ) : (
                                <>
                                    <button type="button" className="btn btn-primary text-white btn-auto d-none" onClick={handleToggleSaveDetails} >Save Welcome Letter {preloaderSaveStatus && (
                                        <>
                                            <div
                                                className="spinner-border small-preloader"
                                                role="status"
                                            >
                                                <span className="visually-hidden">
                                                    {" "}
                                                    Loading...
                                                </span>
                                            </div>
                                        </>
                                    )}</button>

                                    &nbsp;<button type="button" className="btn btn-danger text-white btn-auto" onClick={handleToggleUpdateDetails} >Cancel</button>
                                </>
                            )}

                            {(!enableUpdatePdfDetails) && (
                                <>
                                    <button className='btn btn-warning text-white float-right btn-auto' onClick={handleDownloadPdf}>Generate PDF {preloaderStatus && (
                                        <>
                                            <div
                                                className="spinner-border small-preloader"
                                                role="status"
                                            >
                                                <span className="visually-hidden">
                                                    {" "}
                                                    Loading...
                                                </span>
                                            </div>
                                        </>
                                    )}</button>

                                </>
                            )}




                            {showSanctionNote !== "" && (
                                <div className={sanctionApproveLatestStatus === '0' ? "text-end text-primary" : (sanctionApproveLatestStatus === '1' ? "text-end text-success" : "text-end text-red")}>{showSanctionNote}</div>
                            )}


                        </div>


                    </div>
                </div>
            </div>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <div className='modal-custom rounded'>
                    <div className='modal-head'>
                        <h4 id="modal-title">Lead Document</h4>
                    </div>

                    <div className='modal-body'>
                        <div className='row mb-2 pb-1'>
                            <div className='col-1'>&nbsp;</div>
                            <div className='col-10 ps-0'>{viewModalInfo.note}</div>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* Reject REGISTRATION MODAL START */}
            <Modal open={openRejectAmt} onClose={handleCloseRejectAmt} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='modal-custom rounded'>
                    <div className='modal-head'>
                        <h4 id="modal-title">Enter Notes </h4>
                        <Button onClick={handleCloseRejectAmt} color="primary" className='btn'>
                            <i className="bi bi-x"> &nbsp;</i>
                        </Button>
                    </div>

                    <div className='modal-body'>
                        <form onSubmit={handleSubmit(handleRejectFormSubmit)} encType="multipart/form-data">
                            <div className="row mx-0">

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="itr_file">
                                            <span>Notes <a style={{ color: "red" }}>*</a></span>
                                            < textarea
                                                id='notes'
                                                name='notes'
                                                className='form-control'
                                                {...register('notes')}
                                                onChange={handleAmtRejectChange}

                                            />
                                        </label>
                                    </div>
                                </div>



                                <div className="col-md-12">
                                    <div className="form-group mb-0">
                                        <button className="btn btn-primary mt-2">
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
            {/* Reject REGISTRATION MODAL END */}
        </>
    );
}


function mapStateToProps(state) {
    return {
        usersData: state.usersData,
        getUserModuleData: state.getUserModuleData,
        getUploadLeadDocument: state.getUploadLeadDocument,
        masterDocumentTypeData: state.masterDocumentTypeData,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign(userActions.default, leadActions.default), dispatch),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(WelcomeLetterPage);